<div class="dialog">
  <!-- <div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
  </div> -->

  <div class="modal-body">
    <p>{{message}}</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">OK</button>
  </div>
</div>
